/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { Component, Fragment, Link } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import Title from '../shared/Title';
import MasterResults from '../shared/MasterResults';
import { mp, getCampaign, withCommas } from '../../constants/utils';
import { resultTypes } from '../../constants/constants';
import { palette, breakpoints } from '../../constants/styles';
import Text from './Text';

const BORDER_SPACING = 5;

const StyledTable = styled.table`
  border-collapse: separate;
  border-spacing: ${BORDER_SPACING}px;
  display: block;
  overflow-x: auto;
`;

const StyledTableHeader = styled.th`
  padding: 4px;
  text-align: ${({ textAlignment }) => textAlignment};
  border-bottom: 2px solid ${palette.secondaryColor};
`;

const StyledTableData = styled.td`
${({ idx }) =>
  idx !== 1
    ? `
    border-top: 1px solid ${palette.basicGray};
    `
    : null}
  
  text-align: ${({ textAlignment }) => textAlignment};
`;

const StyledTableContainer = styled.div`
  max-width: 100%;
  margin: 20px 0px;
`;

const FinautaTable = ({
  tableId,
  tableDescription,
  table,
  headersAlignment,
  titlesAlignment,
  cellsAlignment,
}) => {
  return (
    <StyledTableContainer>
      {tableId && (
        <Text type="body1" styles={{ margin: `0px ${BORDER_SPACING * 2}px` }}>
          {tableId}
        </Text>
      )}
      <Title level={5} styles={{ margin: `0px ${BORDER_SPACING * 2}px` }}>
        {tableDescription}
      </Title>
      <StyledTable>
        <thead>
          <tr>
            {table[0].map((header, hidx) => {
              return (
                <StyledTableHeader
                  key={`${header}-${tableId}-${hidx}`}
                  textAlignment={headersAlignment}
                >
                  {header}
                </StyledTableHeader>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {table.map((tableRow, idx) => {
            if (idx !== 0) {
              return (
                <tr key={`r${tableId}-${idx}`}>
                  {tableRow.map((tableData, didx) => (
                    <StyledTableData
                      key={`${tableData}-${idx}-${didx}`}
                      idx={idx}
                      textAlignment={didx === 0 ? titlesAlignment : cellsAlignment}
                    >
                      <Text type="body1">{tableData}</Text>
                    </StyledTableData>
                  ))}
                </tr>
              );
            } else {
              return null;
            }
          })}
        </tbody>
      </StyledTable>
    </StyledTableContainer>
  );
};

FinautaTable.propTypes = {
  headersAlignment: PropTypes.string,
  titlesAlignment: PropTypes.string,
  cellsAlignment: PropTypes.string,
};

FinautaTable.defaultProps = {
  headersAlignment: 'left',
  titlesAlignment: 'left',
  cellsAlignment: 'center',
};

export default FinautaTable;
